// Brand logos helpers for known senders in demo/live data
function getBrandAvatar(senderName = '', senderEmail = '') {
  const name = (senderName || senderEmail || '').toLowerCase();
  if (name.includes('youtube')) {
    return (
      <div className="w-10 h-10 rounded-full bg-red-600 flex items-center justify-center text-white shrink-0 shadow-sm">
        <svg className="w-5 h-5 fill-current" viewBox="0 0 24 24">
          <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z" />
        </svg>
      </div>
    );
  }
  if (name.includes('google play')) {
    return (
      <div className="w-10 h-10 rounded-full bg-white border border-gray-200 flex items-center justify-center shrink-0 shadow-sm">
        <svg className="w-5 h-5" viewBox="0 0 24 24">
          <path fill="#4285F4" d="M3 20.5v-17l11 8.5z" />
          <path fill="#34A853" d="M14 12L3 3.5l12.8 7.3z" />
          <path fill="#FBBC05" d="M14 12l4.8 2.7L3 20.5z" />
          <path fill="#EA4335" d="M14 12l1.8-1.7 3 1.7-3 1.7z" />
        </svg>
      </div>
    );
  }
  if (name.includes('google')) {
    return (
      <div className="w-10 h-10 rounded-full bg-white border border-gray-200 flex items-center justify-center shrink-0 shadow-sm font-bold text-lg">
        <span className="text-[#4285F4]">G</span>
      </div>
    );
  }
  if (name.includes('openai')) {
    return (
      <div className="w-10 h-10 rounded-full bg-black text-white flex items-center justify-center shrink-0 shadow-sm font-bold text-sm">
        <span>AI</span>
      </div>
    );
  }
  if (name.includes('bigbasket')) {
    return (
      <div className="w-10 h-10 rounded-full bg-[#84C225] text-white font-extrabold text-sm flex items-center justify-center shrink-0 shadow-sm">
        bb
      </div>
    );
  }
  if (name.includes('vercel')) {
    return (
      <div className="w-10 h-10 rounded-full bg-black text-white flex items-center justify-center shrink-0 shadow-sm">
        <svg className="w-4 h-4 fill-current" viewBox="0 0 24 24">
          <path d="M12 1L24 22H0L12 1Z" />
        </svg>
      </div>
    );
  }
  if (name.includes('loom')) {
    return (
      <div className="w-10 h-10 rounded-full bg-[#625DF5] text-white flex items-center justify-center shrink-0 shadow-sm">
        <svg className="w-5 h-5 fill-current" viewBox="0 0 24 24">
          <circle cx="12" cy="12" r="8" />
        </svg>
      </div>
    );
  }
  if (name.includes('sunphase')) {
    return (
      <div className="w-10 h-10 rounded-full bg-[#10B981] text-white font-bold text-base flex items-center justify-center shrink-0 shadow-sm">
        S
      </div>
    );
  }
  if (name.includes('notion')) {
    return (
      <div className="w-10 h-10 rounded-full bg-black text-white font-bold text-base flex items-center justify-center shrink-0 shadow-sm">
        N
      </div>
    );
  }
  if (name.includes('slack')) {
    return (
      <div className="w-10 h-10 rounded-full bg-white border border-gray-200 flex items-center justify-center shrink-0 shadow-sm font-extrabold text-xs">
        <span className="text-[#E01E5A]">#</span>
      </div>
    );
  }
  if (name.includes('figma')) {
    return (
      <div className="w-10 h-10 rounded-full bg-black text-white font-bold text-xs flex items-center justify-center shrink-0 shadow-sm">
        F
      </div>
    );
  }

  // Fallback colored initial avatar
  const initial = (senderName || senderEmail || 'E').charAt(0).toUpperCase();
  const colors = [
    'bg-amber-500',
    'bg-rose-500',
    'bg-indigo-500',
    'bg-emerald-500',
    'bg-blue-500',
    'bg-purple-500',
  ];
  const colorIndex = (initial.charCodeAt(0) || 0) % colors.length;

  return (
    <div
      className={`w-10 h-10 rounded-full ${colors[colorIndex]} text-white font-bold text-base flex items-center justify-center shrink-0 shadow-sm`}
    >
      {initial}
    </div>
  );
}

function formatDate(raw) {
  if (!raw) return '';
  try {
    const d = new Date(raw);
    if (isNaN(d.getTime())) return raw;
    const now = new Date();
    const isToday =
      d.getDate() === now.getDate() &&
      d.getMonth() === now.getMonth() &&
      d.getFullYear() === now.getFullYear();

    if (isToday) {
      return d.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
    }
    return d.toLocaleDateString([], { day: 'numeric', month: 'short' });
  } catch {
    return raw;
  }
}

export function MailListItem({ item, isSelected = false, onClickRow }) {
  const sender =
    item.client_name || item.name || item.from_email || item.from || 'Unknown';
  const subject = item.subject || '(No Subject)';
  const snippetText = item.snippet || item.body || item.last_message || '';
  const snippet =
    typeof snippetText === 'string' ? snippetText.replace(/<[^>]*>/g, '') : '';
  const dateStr = formatDate(item.timestamp || item.date);
  const isUnread =
    typeof item.is_unread === 'boolean'
      ? item.is_unread
      : typeof item.is_read === 'boolean'
        ? !item.is_read
        : typeof item.unread === 'boolean'
          ? item.unread
          : Boolean(
              (item.unreadCount && item.unreadCount > 0) ||
              (item.unread_count && item.unread_count > 0),
            );
  const hasAttachment =
    item.has_attachment || Boolean(item.attachments?.length);

  return (
    <div
      onClick={onClickRow}
      className={`group flex items-center gap-2.5 sm:gap-3 px-3 sm:px-4 py-2.5 min-h-[52px] border-b border-gray-100 cursor-pointer select-none transition-all duration-150 ${
        isSelected
          ? 'bg-[#EAF5EF] border-l-4 border-l-primary'
          : isUnread
            ? 'bg-white font-semibold hover:bg-slate-50 shadow-[inset_0_-1px_0_rgba(0,0,0,0.03)]'
            : 'bg-[#F8F9FA] hover:bg-[#F1F3F5] text-gray-600'
      }`}
    >
      {/* Unread Theme Dot Indicator */}
      <div className="w-2.5 h-2.5 flex items-center justify-center shrink-0">
        {isUnread ? (
          <span
            className="w-2 h-2 rounded-full bg-primary ring-2 ring-primary/20 shrink-0"
            title="Unread"
          />
        ) : (
          <span className="w-2 h-2 rounded-full bg-transparent shrink-0 invisible" />
        )}
      </div>

      {/* Avatar logo */}
      <div className="shrink-0">
        {getBrandAvatar(sender, item.from_email || item.from)}
      </div>

      {/* Sender Name */}
      <div
        className={`w-36 sm:w-44 lg:w-52 shrink-0 truncate text-sm transition-colors ${
          isUnread
            ? 'font-bold text-gray-900 tracking-tight'
            : 'font-normal text-gray-600'
        }`}
      >
        {sender}
      </div>

      {/* Subject + Snippet preview */}
      <div className="flex-1 min-w-0 flex items-center gap-2 truncate text-sm">
        {(item.lead_id || item.lead) && (
          <span className="px-1.5 py-0.5 rounded text-[10px] font-bold bg-emerald-100 text-emerald-800 border border-emerald-200 shrink-0">
            Lead
          </span>
        )}
        <span
          className={`truncate transition-colors ${
            isUnread ? 'font-bold text-gray-900' : 'font-normal text-gray-700'
          }`}
        >
          {subject}
        </span>
        <span
          className={`truncate transition-colors ${
            isUnread ? 'text-gray-600 font-normal' : 'text-gray-400 font-normal'
          }`}
        >
          – {snippet.replace(/\n/g, ' ')}
        </span>
      </div>

      {/* Attachment icon */}
      {hasAttachment && (
        <span
          className="text-gray-400 shrink-0 ml-1.5 hover:text-gray-600 transition-colors"
          title="Has attachment"
        >
          <svg
            className="w-4 h-4"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            strokeWidth="2"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M15.172 7l-6.586 6.586a2 2 0 102.828 2.828l6.414-6.586a4 4 0 00-5.656-5.656l-6.415 6.585a6 6 0 108.486 8.486L20.5 13"
            />
          </svg>
        </span>
      )}

      {/* Date/Time */}
      <div
        className={`text-xs sm:text-sm shrink-0 text-right ml-3 min-w-[65px] tabular-nums transition-colors ${
          isUnread ? 'font-bold text-gray-900' : 'text-gray-500 font-normal'
        }`}
      >
        {dateStr}
      </div>
    </div>
  );
}
